// Continuity/grouping ids only — never a security token.
export function generateRandomId(prefix?: string): string {
  const uuid =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : String(Date.now()) + Math.random().toString(16).slice(2);
  return prefix ? `${prefix}-${uuid}` : uuid;
}
